import type { ReactNode } from 'react';
import './disclosure.css';

/** "▸ Where do I find it?" — native <details>, closed by default. */
export function Disclosure({
  summary,
  children,
  defaultOpen,
}: {
  summary: ReactNode;
  children: ReactNode;
  defaultOpen?: boolean;
}) {
  return (
    <details className="disclose" open={defaultOpen}>
      <summary>{summary}</summary>
      {typeof children === 'string' ? <p>{children}</p> : children}
    </details>
  );
}
